export class OutingIteration{
    public id: string;
    public outingId: string;
    public startDate: Date;
    public cost: number;
    public creditCardFee: number;
    public courseId: string;
    public registrationCode: string;
}